import {
  GamesSharesClient,
  GameShareLink,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig, { platformType } from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const gamesClient = new GamesSharesClient(apiConfig, undefined, axiosInstance);

export const handleCreateGameShareLink = async (
  gameId: string
): Promise<GameShareLink> => {
  return (
    await gamesClient.createPlatformGameShareLink(platformType, gameId)
  ).data;
};
